import { useContext } from 'react';
import { HomelessChartsDataContext } from '../contexts/HomelessChartsDataContext';

export const useHomelessChartsDataContext = () => {
    return useContext(HomelessChartsDataContext);
};
